const validateAddressFields = addressToSave => ({
  firstName: addressToSave.firstName,
  lastName: addressToSave.lastName,
  address: addressToSave.address,
  address_1: addressToSave.address_1,
  address_2: addressToSave.address_2,
  number: addressToSave.number,
  zipCode: addressToSave.zipCode,
  city: addressToSave.city,
  county: addressToSave.county,
  state: addressToSave.state,
  region: addressToSave.region,
  country: addressToSave.country,
  countryCode: addressToSave.countryCode,
  location: addressToSave.location,
  phone: addressToSave.phone,
  companyName: addressToSave.companyName,
  email: addressToSave.email,
});

// eslint-disable-next-line import/prefer-default-export
export { validateAddressFields };
